import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {SpacerBuildInControl} from '../SpacerBuildInControl';

export abstract class SpacerBackgroundColorBuiltInControl extends SpacerBuildInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.BLOCK_SPACER].BACKGROUND_COLOR;
  }
}
